import { isGTMEnabled } from '../config/app';

const gtm = {
    init: () => {
        if (!isGTMEnabled) {
            return false;
        }

        // sGTM script via Stape.io
        // : head
        const sGTMHead = document.createElement("script");
        sGTMHead.innerHTML = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://load.srv.capsule.audio/7i3lzljrait.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,\'script\',\'dataLayer\',\'2=aWQ9R1RNLVRTM0wzQlE%3D&page=1\');';
        // : body
        const sGTMBody = document.createElement("noscript");
        sGTMBody.innerHTML = '<iframe src="https://load.srv.capsule.audio/ns.html?id=GTM-TS3L3BQ" height="0" width="0" style="display:none;visibility:hidden"></iframe>';

        document.head.prepend(sGTMHead);
        document.body.prepend(sGTMBody);
    },
    dataLayer: (data) => {
        if (!isGTMEnabled) {
            return false;
        }

        if (window.dataLayer) {
            try {
                window.dataLayer.push(data);
            } catch (e) {
                console.error("dataLayer error", e);
            }
        }
    }
};

export default gtm;
